/**
 * Shared style tokens for standalone / full-bleed dashboard pages that render
 * content inside MUI Card or Paper components.
 */

/** Applies to `Card variant="outlined"` content cards throughout standalone pages. */
export const contentCardSx = {
  borderRadius: 2,
};

/**
 * MUI `borderRadius` multiplier used by CareStart action buttons / cards.
 * Matches the legacy standaloneLayoutTokens value (2 = theme.shape.borderRadius units).
 */
export const RADIUS_MEDIUM = 2;
